import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withKeys as _withKeys, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_input = _resolveComponent("q-input")!

  return (_openBlock(), _createBlock(_component_q_input, {
    ref: "input",
    "model-value": _ctx.modelValue,
    placeholder: _ctx.placeholder,
    "input-class": "text-caption",
    dense: "",
    outlined: "",
    class: "col",
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', $event))),
    onKeyup: _withKeys(_withModifiers(_ctx.close, ["stop"]), ["escape"])
  }, {
    append: _withCtx(() => [
      (_ctx.modelValue)
        ? (_openBlock(), _createBlock(_component_q_icon, {
            key: 0,
            name: "fa fa-times",
            size: "xs",
            class: "cursor-pointer",
            onClick: _ctx.clear
          }, null, 8, ["onClick"]))
        : (_openBlock(), _createBlock(_component_q_icon, {
            key: 1,
            name: "fa fa-search",
            size: "xs"
          }))
    ]),
    _: 1
  }, 8, ["model-value", "placeholder", "onKeyup"]))
}